export function isComposingKeyEvent(event: KeyboardEvent): boolean {
  // isComposing covers modern browsers; keyCode 229 is the historical
  // Safari/older-browser signal for "IME is mid-composition."
  return event.isComposing || event.keyCode === 229;
}
